import { type FC } from 'react';
import { Center, Text } from '@eqi-investimentos/react';

export const HasRecommendationTag: FC<HasRecommendationTagProps> = ({ t }) => {
  return (
    <>
      <Center
        id="badge-recomendation-header"
        minW="8.875rem"
        h="1.75rem"
        p="xs"
        gap="0.625rem"
        bgColor="background.tertiary"
        borderRadius="0.125rem"
        transition="0.4s all ease-in-out"
      >
        <Text
          size="xl"
          fontWeight="normal"
          lineHeight="4"
          color="content.primary"
          whiteSpace="nowrap"
          overflow="hidden"
          transition="0.4s all ease-in-out"
        >
          {t('widgets.RecentContentWidget.hasRecommendation')}
        </Text>
      </Center>
    </>
  );
};

type HasRecommendationTagProps = {
  t: (key: string) => string;
};
